import { Employee } from "./CRUDs/entities/Employee";

/** Called from employees table map column <td onclick="..."> so the whole cell opens the tracker. */
window.showEmployeeJobsMap = function (id, event) {
    if (event && typeof event.stopPropagation === 'function') {
        event.stopPropagation();
    }
    const numericId = typeof id === 'number' ? id : parseInt(String(id), 10);
    if (!Number.isInteger(numericId)) {
        return;
    }
    const employee = new Employee(numericId);
    employee.showJobsMap(numericId);
};

export default {
    init() {},
}